import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormExecHospitComponent } from "./form-exec-hospit/form-exec-hospit.component";
import { FormPresHospitComponent } from "./form-pres-hospit/form-pres-hospit.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
type ViewMode = 'exec' | 'pres';


@Component({
  selector: 'app-form-exploitation-hospit',
  imports: [FormExecHospitComponent, FormPresHospitComponent,FormsModule,CommonModule],
  templateUrl: './form-exploitation-hospit.component.html',
  styleUrl: './form-exploitation-hospit.component.scss'
})
export class FormExploitationHospitComponent {
 viewMode: ViewMode = 'pres'; // Default view
  @Input() itemBeneficiare:any
  @Input() selectedDemandeHospitalisation:any
  @Output() updateParent = new EventEmitter<any>();




  setView(mode: 'exec' | 'pres'): void {
    this.viewMode = mode;
  }

    ngOnChanges(changes: SimpleChanges) {
      console.log('changesxxx: ',changes)
    if (changes['itemBeneficiare'] && changes['itemBeneficiare'].currentValue) {
      console.log("changes['itemBeneficiare']xxx: ",changes['itemBeneficiare'])
      this.itemBeneficiare = changes['itemBeneficiare'].currentValue
    
    }
    if (changes['selectedDemandeHospitalisation'] && changes['selectedDemandeHospitalisation'].currentValue) {
      console.log("changes['selectedDemandeHospitalisation']xx: ",changes['selectedDemandeHospitalisation'])
      this.selectedDemandeHospitalisation = changes['selectedDemandeHospitalisation'].currentValue
    
    }
  }

  onUpdateParent(event:any){
    this.updateParent.emit(event)
  }
}
